import React, { useState } from 'react';
import { Card } from '../card/card';
import { FloatingObject } from '../floating-object/floating-object';
import { PositionType } from '../../../utils/calculate-position';
import { cn } from '../../../utils/tailwind';

type DropdownProps = {
    children: React.ReactNode;
    content: React.ReactNode | string;
    position?: PositionType;
    block?: boolean;
    size?: 'small' | 'medium';
    arrowPosition?: number;
};

export const Dropdown: React.FC<DropdownProps> = ({
    children,
    content,
    position = 'bottom-right',
    block = false,
    size = 'medium',
    arrowPosition,
}) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    const trigger = (
        <div className={cn('relative z-[900] hover:z-[910]', block ? 'block' : 'inline-flex')} data-dropdown-wrapper>
            <div className={cn('pl-[1rem] -ml-[1rem]', block ? 'block' : 'inline-flex')} data-dropdown-trigger>
                {children}
            </div>
        </div>
    );

    return (
        <FloatingObject
            trigger={trigger}
            content={
                <Card padding="vsmall" shadow="medium">
                    <>{content}</>
                </Card>
            }
            position={position}
            isVisible={isDropdownVisible}
            setIsVisible={setIsDropdownVisible}
            arrowPosition={arrowPosition}
            block={block}
            size={size}
            protectiveZone={15}
        />
    );
};
